import React from 'react'
import styled from 'styled-components'

import { SectionCommonProps, } from '../types'

interface Props extends SectionCommonProps {
}

const members = [
  {
    name: 'Jae Young',
    role: 'CEO / Core Member / Engineering',
    profileImage: require('./assets/images/x86kernel.png'),
    resumes: [
      '소프트웨어 마에스트로 9기',
      '차세대보안리더 양성 프로그램 Best of the Best 3기',
      '국군사이버사령부 소프트웨어 개발병 전역',
    ],
  },
  {
    name: 'Alice',
    role: 'Core Member / Planning & UIUX',
    profileImage: require('./assets/images/team-alice.webp'),
    resumes: [
      '광동어 / 중국어 / 영어 / 한국어',
      '다수의 스타트업 기획 및 UI/UX 디자인 경험',
    ],
  },
]

const Section4Container = styled.section`
  scroll-margin-top: 72px;
  padding: 88px 0;
  background: #ffffff;

  @media (max-width: 760px) {
    scroll-margin-top: 64px;
    padding: 48px 0;
  }
`

const TeamContainer = styled.div`
  width: min(1120px, calc(100% - 40px));
  margin: 0 auto;

  @media (max-width: 760px) {
    width: calc(100% - 32px);
  }
`

const TeamHeader = styled.div`
  max-width: 760px;
  margin-bottom: 34px;

  .eyebrow {
    display: inline-flex;
    align-items: center;
    min-height: 32px;
    padding: 0 12px;
    border-radius: 8px;
    color: #0f7f6c;
    background: rgba(115, 223, 196, 0.18);
    border: 1px solid rgba(15, 127, 108, 0.22);
    font-size: 14px;
    font-weight: 800;
  }

  h2 {
    margin: 14px 0 0;
    color: #152236;
    font-size: 34px;
    line-height: 1.25;
    letter-spacing: 0;
  }

  p {
    margin: 14px 0 0;
    color: #5b697c;
    font-size: 17px;
    line-height: 1.7;
  }

  @media (max-width: 760px) {
    margin-bottom: 24px;

    .eyebrow {
      min-height: 28px;
      padding: 0 10px;
      font-size: 12px;
    }

    h2 {
      margin-top: 10px;
      font-size: 23px;
      line-height: 1.32;
    }

    p {
      margin-top: 10px;
      font-size: 14px;
      line-height: 1.65;
    }
  }
`

const MemberGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`

const MemberCard = styled.article`
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  min-height: 280px;
  border-radius: 8px;
  overflow: hidden;
  background: #f8faf9;
  border: 1px solid #e4eaf0;
  box-shadow: 0 12px 32px rgba(17, 34, 51, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;

  &:hover {
    transform: translateY(-5px);
    border-color: rgba(115, 223, 196, 0.7);
    box-shadow: 0 20px 44px rgba(17, 34, 51, 0.1);
  }

  @media (max-width: 980px) {
    grid-template-columns: 150px minmax(0, 1fr);
  }

  @media (max-width: 760px) {
    grid-template-columns: 96px minmax(0, 1fr);
    min-height: 0;
  }

  @media (max-width: 480px) {
    grid-template-columns: 88px minmax(0, 1fr);
  }
`

const MemberImage = styled.div`
  background: #eef3f2;
  height: 100%;

  img {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 280px;
    object-fit: cover;
  }

  @media (max-width: 760px) {
    align-self: stretch;

    img {
      height: 100%;
      min-height: 144px;
      object-fit: cover;
      object-position: center top;
    }
  }

  @media (max-width: 480px) {
    img {
      min-height: 132px;
    }
  }
`

const MemberBody = styled.div`
  padding: 24px;

  .role {
    display: inline-flex;
    color: #0f7f6c;
    font-size: 14px;
    font-weight: 800;
  }

  h3 {
    margin: 10px 0 0;
    color: #152236;
    font-size: 26px;
    line-height: 1.25;
  }

  @media (max-width: 760px) {
    padding: 16px;

    .role {
      font-size: 12px;
      line-height: 1.4;
    }

    h3 {
      margin-top: 6px;
      font-size: 20px;
    }
  }

  @media (max-width: 480px) {
    padding: 14px;

    .role {
      font-size: 11px;
      line-height: 1.35;
    }

    h3 {
      margin-top: 5px;
      font-size: 18px;
    }
  }
`

const ResumeList = styled.ul`
  display: grid;
  gap: 9px;
  margin: 20px 0 0;
  padding: 0;
  list-style: none;

  li {
    color: #5b697c;
    font-size: 14px;
    line-height: 1.55;
  }

  li:before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    margin-right: 8px;
    border-radius: 50%;
    background: #73dfc4;
    vertical-align: 2px;
  }

  @media (max-width: 760px) {
    gap: 6px;
    margin-top: 10px;

    li {
      font-size: 12px;
      line-height: 1.4;
    }

    li:nth-child(n + 3) {
      display: none;
    }
  }

  @media (max-width: 480px) {
    li {
      font-size: 11px;
    }
  }
`

function Section4(props: Props) {
  return (
    <Section4Container { ...props }>
      <TeamContainer>
        <TeamHeader>
          <div className='eyebrow'>Team</div>
          <h2>프로젝트마다 주요 멤버가 직접 함께합니다.</h2>
          <p>
            상담부터 설계, 디자인, 개발 방향까지 주요 멤버가 직접 참여해 프로젝트의 흐름을 맞춥니다.
          </p>
        </TeamHeader>
        <MemberGrid>
          {
            members.map((member) => (
              <MemberCard key={ member.name }>
                <MemberImage>
                  <img src={ member.profileImage } alt={ member.name } />
                </MemberImage>
                <MemberBody>
                  <span className='role'>{ member.role }</span>
                  <h3>{ member.name }</h3>
                  <ResumeList>
                    {
                      member.resumes.map((resume) => (
                        <li key={ resume }>{ resume }</li>
                      ))
                    }
                  </ResumeList>
                </MemberBody>
              </MemberCard>
            ))
          }
        </MemberGrid>
      </TeamContainer>
    </Section4Container>
  )
}

export default Section4
